
import ManageEmailRoute from '@/views/Email/ManageEmail/router'

export default [
  {
    path: '',
    component: () => import(/* webpackChunkName: "email" */ '@/views/Email/ManageEmail/Index.vue'),
    children: ManageEmailRoute
  }
]
